import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { BreadcrumbsNavComponent } from '@/app/components/breadcrumbs/breadcrumbs.component';
import { ToastContainerComponent } from '@/app/components/toast/toast.component';
import { SpinnerComponent } from '@/app/components/spinner/spinner.component';
import { CountdownPopupComponent } from '@/app/shared/components/countdown-popup/countdown-popup.component';
import { FloatingBallComponent } from '@/app/components/ai-assistant/floating-ball/floating-ball.component';
import { filter, map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { getPath, PathUnit } from '@/app/consts/path.const';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    SideNavComponent,
    // BreadcrumbsNavComponent,
    ToastContainerComponent,
    SpinnerComponent,
    CountdownPopupComponent,
    FloatingBallComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {

  private router = inject(Router);

  currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(event => {
        return event.urlAfterRedirects;
      })
    ),
    { initialValue: this.router.url || '' } // 改为 router.url 避免初始为空导致 computed 误判
  );

  ngOnInit() {
  }
}